import React, { useEffect, useRef } from 'react'
import './working.scss'
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

const Working = () => {
  const sectionRef = useRef(null);
  const cardRefs = useRef([]);

  useEffect(() => {
    const cards = cardRefs.current;

    const initialPositions = [
      { x: 0, y: 100, opacity: 0 },
      { x: 0, y: 150, opacity: 0 },
      { x: 0, y: 200, opacity: 0 },
      { x: 0, y: 250, opacity: 0 },
    ];

    cards.forEach((card, index) => {
      gsap.fromTo(
        card,
        initialPositions[index],
        {
          x: 0,
          y: 0,
          opacity: 1,
          duration: 1,
          ease: "power3.out",
          scrollTrigger: {
            trigger: card,
            start: "top 120%",
            toggleActions: "play none none none",
            //   markers: true
          },
        }
      );

      gsap.set(card, { transformOrigin: "center" });

      card.addEventListener("mouseenter", () => {
        gsap.to(card, { scale: 1.05, duration: 0.3 });
      });

      card.addEventListener("mouseleave", () => {
        gsap.to(card, { scale: 1, duration: 0.3 });
      });
    });
  }, []);
  return (
    <>
      <section className='workingmainprnt'>
        <div className="custom-container" ref={sectionRef}>
          <div className="workingmainchld">

            <div className="imgleftworking displaynoneonmobile">
              <img className='img-fluid' src="\assets\Chatandpay\workingflowimg.png" alt="img" />
            </div>
            <div className="imgleftworking d-none displayshowonmobile">
              <img className='img-fluid' src="\assets\Chatandpay\workingflowimgmbl.png" alt="img" />
            </div>

            <div className="rightcntworking">
              <h2>How It Works</h2>
              <div className="leftcntchldworking" ref={(el) => (cardRefs.current[0] = el)}>
                <h3>01. Start a Chat</h3>
                <p>Search for a friend or open a new conversation.</p>
              </div>
              <div className="leftcntchldworking" ref={(el) => (cardRefs.current[1] = el)}>
                <h3>02. Send Crypto</h3>
                <p>Tap the send button, choose a currency and amount.</p>
              </div>
              <div className="leftcntchldworking" ref={(el) => (cardRefs.current[2] = el)}>
                <h3>03. Payment Received</h3>
                <p>The recipient gets a payment request and can choose to approve or decline it.</p>
              </div>
              <div className="leftcntchldworking" ref={(el) => (cardRefs.current[3] = el)}>
                <h3>04. Instant Confirmation</h3>
                <p>Once accepted, a confirmation message appears in the chat.</p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default Working